export const WHOAMI_TIMEOUT_MS = 30_000
export const LOGIN_TIMEOUT_MS = 300_000
export const DEPLOY_TIMEOUT_MS = 900_000
export const ENV_TIMEOUT_MS = 30_000
export const ENV_ADD_TIMEOUT_MS = 30_000
export const ENV_PULL_TIMEOUT_MS = 60_000
/** Non-interactive provisioning can't wait on a human; keep it bounded. */
export const PROVISION_TIMEOUT_MS = 180_000
/** Interactive provisioning waits on the user clicking through Vercel's prompts. */
export const INTERACTIVE_PROVISION_TIMEOUT_MS = 600_000
export const INSPECT_TIMEOUT_MS = 30_000
export const FORMAT_TIMEOUT_MS = 30_000
export const OXFMT_FORMAT_TIMEOUT_MS = 15_000
export const LOCKFILE_REFRESH_TIMEOUT_MS = 120_000
export const DEFAULT_TIMEOUT_MS = 120_000
export const DEFAULT_CAPTURE_TIMEOUT_MS = 120_000
